import React from 'react';
import PreviewQuestionShell from './PreviewQuestionShell';

const TextQuestionBlock = ({ question, register, errors }) => {
    const validationRules = {
        required: question.required ? `${question.title} is required` : false,
        maxLength: question.maxLength || undefined,
        min: question.minValue || undefined,
        max: question.maxValue || undefined,
    };

    switch (question.inputType) {
        case 'email':
            validationRules.pattern = {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Please enter a valid email address',
            };
            break;
        case 'url':
            validationRules.pattern = {
                value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/,
                message: 'Please enter a valid URL',
            };
            break;
        case 'tel':
            validationRules.pattern = {
                value: /^[+]?[0-9\s-]{7,15}$/,
                message: 'Please enter a valid phone number',
            };
            break;
        case 'number':
        case 'range':
            validationRules.valueAsNumber = true;
            break;
        default:
            break;
    }

    return (
        <PreviewQuestionShell
            question={question}
            error={errors[question.internalId]?.message}
        >
            <input
                type={question.inputType || 'text'}
                className="form-control form-control-sm"
                placeholder={question.placeholder}
                {...register(question.internalId, validationRules)}
            />
        </PreviewQuestionShell>
    );
};

export default TextQuestionBlock;
